import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as UserIcon } from '@/assets/images/icons/user_icon.svg';
import { ReactComponent as LockIcon } from '@/assets/images/icons/lock_icon.svg';
import { ReactComponent as InfoIcon } from '@/assets/images/icons/info_icon.svg';
import SecurityComponent from '@/container/Profile/Security';
import AccountComponent from '@/container/Profile/Account';
import InformationComponent from '@/container/Profile/BillingInformation';
import { GlobalContext } from '@/contexts/GlobalContext';

import './index.scss';

function ProfilePage() {
  const navigate = useNavigate();
  const { hash } = useLocation();
  const { t } = useTranslation();
  const { setPageTitle, setTriggerFetchProfile } = useContext(GlobalContext);

  useEffect(() => {
    setPageTitle({
      title: t('profile_page.page_title'),
    });
    setTriggerFetchProfile(true);
  }, [setPageTitle, t, setTriggerFetchProfile]);

  const [activeTab, setActiveTab] = useState();
  const items = [
    {
      label: (
        <span>
          <UserIcon /> {t('profile_page.select_tabs.account')}
        </span>
      ),
      key: '#account',
      children: <AccountComponent />,
    },
    {
      label: (
        <span>
          <LockIcon /> {t('profile_page.select_tabs.security')}
        </span>
      ),
      key: '#security',
      children: <SecurityComponent />,
    },
    {
      label: (
        <span>
          <InfoIcon /> {t('profile_page.select_tabs.billing_infomation')}
        </span>
      ),
      key: '#billing-information',
      children: <InformationComponent />,
    },
  ];

  useEffect(() => {
    setActiveTab(hash || '#account');
  }, [hash]);

  const handleOnClickChangeTab = (key) => {
    setActiveTab(key);
    navigate(`${window.location.pathname}${key}`);
  };

  return (
    <div className="profile-page">
      <Tabs
        items={items}
        activeKey={activeTab}
        onTabClick={handleOnClickChangeTab}
        destroyInactiveTabPane
      />
    </div>
  );
}

export default ProfilePage;
